// Tiles
import { BASE_URL } from '../../../config';
import { PATIENT_TYPE_OPTIONS } from '../../../constants';
import {
  COVID_TEST_SERVICE_ID,
  FLU_SHOT_SERVICE_ID,
  PREGNANCY_TEST_SERVICE_ID,
  STD_TEST_SERVICE_ID,
} from '../../../constants/services';
import { URGENT_CARE_VALUE } from '../Tiles/ProviderTypes';
import { IS_FLU_SEASON } from '../../../config';

export interface Service {
  name: string;
  providerType?: string;
  patientType?: typeof PATIENT_TYPE_OPTIONS[number];
  serviceIds?: string[];
  searchOverride?: string;
  searchType?: 'symptom' | 'service' | 'provider-type';
  onClick?: () => void;
  visible?: boolean;
}

export const services: Service[] = [
  {
    name: 'Pediatric urgent care',
    patientType: PATIENT_TYPE_OPTIONS[1],
    searchType: 'provider-type',
    visible: true,
  },
  {
    name: 'COVID-19 vaccine',
    onClick: () => {
      window.location.href = `${BASE_URL}/covid-vaccine`;
    },
    visible: true,
  },
  {
    name: 'Rapid COVID test',
    serviceIds: [COVID_TEST_SERVICE_ID],
    searchType: 'service',
    visible: true,
  },
  {
    name: 'Flu shot',
    serviceIds: [FLU_SHOT_SERVICE_ID],
    searchType: 'service',
    visible: IS_FLU_SEASON,
  },
  {
    name: 'General issue',
    searchOverride: '',
    visible: true,
  },
  {
    name: 'Prescription fill',
    visible: true,
  },
  {
    name: 'Flu, cold, or cough',
    visible: true,
  },
  {
    name: 'Fever',
    visible: true,
  },
  {
    name: 'Sore throat',
    visible: true,
  },
  {
    name: 'Rash',
    visible: true,
  },
  {
    name: 'Pink eye',
    visible: true,
  },
  {
    name: 'Minor injury',
    visible: true,
  },
  {
    name: 'Allergies',
    visible: true,
  },
  {
    name: 'STD test',
    serviceIds: [STD_TEST_SERVICE_ID],
    searchType: 'service',
    visible: true,
  },
  {
    name: 'Pregnancy test',
    serviceIds: [PREGNANCY_TEST_SERVICE_ID],
    searchType: 'service',
    visible: true,
  },
  {
    name: 'UTI',
    visible: true,
  },
];

/**
 * Returns a search update object
 */
export function getSearchUpdate(service: Service) {
  const update: any = {
    type: service.searchType ?? 'symptom',
    name: service.searchOverride ?? service.name,
    provider_type: service.providerType ?? URGENT_CARE_VALUE,
    highlight: service.searchOverride ?? service.name,
    patientType: service.patientType ?? PATIENT_TYPE_OPTIONS[0],
  };

  if (service.serviceIds) update.id = [...service.serviceIds, URGENT_CARE_VALUE].join('_');

  return update;
}
